/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
/* GLOBAL  */
import React from 'react';
import ReactDOM from 'react-dom';
import smoothscroll from 'smoothscroll-polyfill';

import Root from './root';

console.log(`${PRODUCT} - v${VERSION}`);

if (!PRODUCTION) {
  console.log('Environment', window._env_);
}

smoothscroll.polyfill();

const rootDom = document.getElementById('root');

ReactDOM.render(<Root />, rootDom);
